<template>
  <AntLocaleProvider :locale="locale">
    <router-view />
  </AntLocaleProvider>
</template>

<script>
import { LocaleProvider as AntLocaleProvider } from 'ant-design-vue';

import { getAntdLocale } from '@/common/lang';

export default {
  components: { AntLocaleProvider },
  data() {
    return {
      locale: {},
    };
  },
  beforeCreate() {
    getAntdLocale().then((locale) => {
      this.locale = locale;
    });
  },
};
</script>
